// Packages
import cn from 'classnames';
// Components
import { Spinner } from 'components/lib';
// Styles
import styles from './loader.module.scss';

interface IProps {
  isLoading?: boolean;
  // The router's loader while a page's code loads: its dots stay where the app loader drew them.
  isRouteFallback?: boolean;
}

// A spinner over the page while it loads. A page-shaped placeholder here matched no page: this one
// loader stands in for every details page, form and tab, so it cannot know the shape of what loads.
const Loader = ({ isLoading = false, isRouteFallback = false }: IProps) =>
  isLoading ? (
    <div
      className={cn(styles.loaderWrap, { [styles.routeFallback]: isRouteFallback })}
      data-cy="page-loader"
    >
      <Spinner size={30} isLoading />
    </div>
  ) : null;

export default Loader;
